// **********************
// utils/cacheBusting.js
// **********************
import { VERSION } from "../constants";

/// LOCAL FUNCTIONS:
const refreshCacheAndReload = async (metaVersion) => {
  try {
    if (window?.caches) {
      const { caches } = window;
      const cacheNames = await caches.keys();
      const cacheDeletionPromises = cacheNames.map((n) => caches.delete(n));

      await Promise.all(cacheDeletionPromises);
      
      // Store the metaVersion in localStorage
      localStorage.setItem('metaVersion', metaVersion);

      console.log('The cache has been deleted.');
      // @ts-ignore: Firefox still has a `forceReload` parameter.
      window.location.reload(true);
    }
  } catch (error) {
    console.log('An error occurred while deleting the cache.', true);
    console.log(error, true);
  }
};

export async function c10CacheBuster(currentVersion = VERSION) {
  const storedMetaVersion = localStorage.getItem('metaVersion');

  // If the storedMetaVersion matches the currentVersion, this means that the page has already been reloaded and the cache has been cleared
  if (storedMetaVersion === currentVersion) {
    return;
  }

  if (!currentVersion) return;

  try {
    const res = await fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache' });
    const { version: metaVersion } = await res.json();
    console.log('metaVersion:', metaVersion);

    const shouldForceRefresh = metaVersion > currentVersion; // straight string compare for now
    if (shouldForceRefresh) {
      console.log(`New version (v${metaVersion}) > current version (v${currentVersion}). Forcing a refresh.`);
      refreshCacheAndReload(metaVersion);
    }
    //else {
    //  console.log('There is no new version. No cache refresh needed.');
    //}
  } catch (error) {
    console.log('An error occurred while checking cache status.', true);
    console.log(error, true);
  }
}